import { render, staticRenderFns } from "./ResearchManagers.vue?vue&type=template&id=6e6d9454&scoped=true"
import script from "./ResearchManagers.vue?vue&type=script&lang=ts"
export * from "./ResearchManagers.vue?vue&type=script&lang=ts"
import style0 from "./ResearchManagers.vue?vue&type=style&index=0&id=6e6d9454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d9454",
  null
  
)

export default component.exports